import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CredentialsService } from '../core/credentials.service';
import { SyncedPatient } from '../models';

@Injectable({ providedIn: 'root' })
export class SyncedPatientsService {

  constructor(private http: HttpClient, private credentialsService: CredentialsService, @Inject('BASE_URL') private baseUrl: string) {}

  findAll(query: {where?: any; limit?: number; skip?: number; order?: string}): Observable<SyncedPatient[]> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.credentialsService.getAccessToken() });
    if (query) {
      for (const key in query) {
        query[key] = JSON.stringify(query[key]);
      }
    }
    return this.http.get<SyncedPatient[]>(`${this.baseUrl}/v2/synced-patients`, { headers, params: <any>query });
  }

  findById(id: string, ): Observable<SyncedPatient> {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.credentialsService.getAccessToken() });
    return this.http.get<SyncedPatient>(`${this.baseUrl}/v2/synced-patients/${id}`, { headers,  });
  }

}
